import React from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import Navbar from '../Components/Navbar'
import Profile from './Profile'
import Tweets from '../Components/Tweets'

const Main = ({userName, setUserName, SignOut, profilePic, setProfilePic}) => {


  return (
    <Router>
      <Switch>
          <Route exact path="/">
            <Navbar userName={userName} SignOut={SignOut} />
            <Tweets userName={userName} profilePic={profilePic} />
          </Route>
          <Route path="/profile">
            <Navbar userName={userName} SignOut={SignOut} />
            <Profile 
              setUserName={setUserName} 
              userName={userName}
              profilePic={profilePic}
              setProfilePic={setProfilePic}
            />
          </Route>
        </Switch>
    </Router>
  )
}

export default Main
